import { Box, Container, Typography } from "@mui/material";
import React from "react";

interface PriceProps {
  regularPrice: number;
  salePrice: number;
  regularDiscount: number;
}

const Price: React.FC<PriceProps> = (props) => {
  return (
    <Container>
      <Box
        className={
          props.regularDiscount > 0
            ? "flex flex-row items-center gap-5"
            : "hidden"
        }
      >
        <Typography variant="body1">Giá niêm yết</Typography>
        <Typography
          variant="h6"
          className="text-red-500 !ml-3 !font-bold line-through"
        >
          {props.regularPrice?.toLocaleString()} <sup>đ</sup>
        </Typography>
      </Box>
      <Box className=" flex flex-row items-center ">
        <Box
          className="flex items-center bg-center rounded-lg overflow-hidden w-[250px] min-h-14"
          style={{
            backgroundImage: "url('/images/bg-price.png')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Typography
            variant="inherit"
            className="!font-bold px-3 pt-[10px] text-[#0056b3] whitespace-nowrap overflow-hidden text-ellipsis"
          >
            GIÁ BÁN
          </Typography>
          <Typography
            variant="h5"
            className="font-bold  pt-[10px]  text-white flex-1 text-center"
          >
            {props.regularPrice === 0 ? (
              <span>liên hệ</span>
            ) : props.regularDiscount > 0 ? (
              props.regularDiscount?.toLocaleString()
            ) : (
              props.regularPrice?.toLocaleString()
            )}
            {props.regularPrice === 0 ? <></> : <sup>đ</sup>}
          </Typography>
        </Box>
        <Typography
          variant="body2"
          className="pt-[10px] text-gray-800 flex-1 pl-5"
        >
          (Đã bao gồm VAT)
        </Typography>
      </Box>
      <Box
        className={props.regularDiscount > 0 ? "flex items-center" : "hidden"}
      >
        <Typography variant="body1" className="primary_blue">
          Tiết kiệm
        </Typography>
        <Typography
          variant="h6"
          className="text-primary_blue !ml-3 !font-bold "
        >
          {props.salePrice?.toLocaleString()} <sup>đ</sup>
        </Typography>
      </Box>
    </Container>
  );
};

export default Price;
